import { render, staticRenderFns } from "./PlusMinusField.vue?vue&type=template&id=6b4e5c06&scoped=true"
import script from "./PlusMinusField.vue?vue&type=script&lang=js"
export * from "./PlusMinusField.vue?vue&type=script&lang=js"
import style0 from "./PlusMinusField.vue?vue&type=style&index=0&id=6b4e5c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e5c06",
  null
  
)

export default component.exports